<template>
  <b-container class="report-page">
    <b-form>
      <b-row>
        <b-col>
          <b-form-group>
            <label>{{ $t('deviation_report.stop') }}</label>
            <vSelect
              :options="availableStopList"
              v-model="selectedStop"
              label="stopId"
            />
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group>
            <label>{{ $t('report.start_date') }}</label>
            <b-form-datepicker
              :placeholder="this.$t('datepicker.labelNoDateSelected')"
              v-model="startDate"
              :locale="this.$t('datepicker.locale')"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                weekday: 'short',
              }"
            >
            </b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <label>{{ $t('report.end_date') }}</label>
            <b-form-datepicker
              :placeholder="this.$t('datepicker.labelNoDateSelected')"
              v-model="endDate"
              :locale="this.$t('datepicker.locale')"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                weekday: 'short',
              }"
            >
            </b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="btn-row">
        <b-col>
          <b-button
            class="btn-success btn-report"
            @click="submit(contentTypeXls)"
            :disabled="!isValidForm || loading"
          >
            <b-icon icon="download" scale="1.2"></b-icon>
            {{ $t('report.download') }}
          </b-button>
          <b-button
            class="btn-success btn-report"
            @click="submit(contentTypeCsv)"
            :disabled="!isValidForm || loading"
          >
            <b-icon icon="download" scale="1.2"></b-icon>
            {{ $t('report.download_csv') }}
          </b-button>
        </b-col>
      </b-row>
      <RequestInfo
        :type="infoType"
        :ok="!error && showRequestResult"
        :error="error && showRequestResult"
        :loader="loading"
        :additionalErrorMsg="responseError"
      />
    </b-form>
  </b-container>
</template>

<script>
import deviationReport from '@/store/report2/deviationReport'
import vSelect from 'vue-select'
import moment from 'moment'
import ContentType from '@/util/enums/contentType'

export default {
  components: { vSelect },

  data() {
    return {
      selectedStop: null,
      startDate: null,
      endDate: null,
      showRequestResult: false,
      loading: false,
      buttonDisabled: false,
      error: false,
      responseError: null,
      infoType: 'request',
      contentTypeXls: 'XLS',
      contentTypeCsv: 'CSV',
    }
  },

  computed: {
    availableStopList() {
      return this.$store.state.deviationReport.availableStops
    },
    isValidForm() {
      if (this.selectedStop && this.startDate && this.endDate) return true
      else return false
    },
  },
  beforeCreate() {
    if (!this.$store.state.deviationReport) {
      this.$store.registerModule('deviationReport', deviationReport)
    }
    this.$store.dispatch('deviationReport/getAvailableStops')
  },
  created() {},
  watch: {
    loading: function (val) {
      this.showRequestResult = !val
    },
  },
  methods: {
    saveToFile(data, fileName, type) {
      if (!(type in ContentType)) {
        console.error(`Unsupported type ${type}`)
        this.error = true
        this.loading = false
        return
      }

      const fileType = ContentType[type]

      const blob = new Blob([data], {
        type: fileType.mime,
      })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      link.click()
      URL.revokeObjectURL(link.href)
    },
    submit(type) {
      if (!(type in ContentType)) {
        console.error(`Unsupported type`, type)
        this.error = true
        this.loading = false
        return
      }

      const fileType = ContentType[type]

      this.responseError = null
      this.error = false
      this.loading = true

      const startTime = new moment(this.startDate, 'YYYY-MM-DD')
      const endTime = new moment(this.endDate, 'YYYY-MM-DD')
      const params = {
        stop: this.selectedStop.stopId,
        startTime: startTime.format('YYYY-MM-DD[T]HH:mm:ss'),
        endTime: endTime.format('YYYY-MM-DD[T]23:[59:59]'),
      }

      const dispatchPath =
        'deviationReport/stopDeviationGenerateAndExport' +
        fileType.fileExt.charAt(0).toUpperCase() +
        fileType.fileExt.slice(1)

      this.$store
        .dispatch(dispatchPath, params)
        .then((response) => {
          if (response.data?.code) {
            const code = response.data.code
            if (code != 200) {
              this.responseError = this.$t('response.server_error')
              this.error = true
              console.error(response.data)
            } else {
              this.saveToFile(
                response.data,
                `deviationReport_stop_${params.stop}.${fileType.fileExt}`,
                type
              )
            }
          } else {
            this.saveToFile(
              response.data,
              `deviationReport_stop_${params.stop}.${fileType.fileExt}`,
              type
            )
          }
        })
        .catch(() => {
          this.responseError = this.$t('response.server_error')
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
